import { getTimeString, TimeMode } from "@opendash/core";
import { CustomParseFieldProps, ParseField } from "@opendash/plugin-parse";
import { Typography } from "antd";

import React from "react";

type PlannedTimeFieldProps = CustomParseFieldProps<any>;

const PlannedTimeField = ({
  setValue,
  parseObject,
  value,
  fieldname,
}: PlannedTimeFieldProps) => {
  if (setValue) {
    return (
      <ParseField object={parseObject} field={fieldname} isInline={true} />
    );
  }
  const startString = parseObject?.get("planStart")
    ? getTimeString(
        TimeMode.DateMode,
        "full",
        "ms",
        parseObject?.get("planStart")?.getTime()
      )
    : " / ";
  const endString = parseObject?.get("planEnd")
    ? getTimeString(
        TimeMode.DateMode,
        "full",
        "ms",
        parseObject?.get("planEnd")?.getTime()
      )
    : " / ";
  return (
    <Typography.Text type="secondary">{`${startString} - ${endString}`}</Typography.Text>
  );
};

export { PlannedTimeField, PlannedTimeFieldProps };
